import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ALL_CREWS } from "../constants/HomeScreen";

const initialState = {
  isLoading: false,
  items: [],
  message: "",
  statusText: "",
  severity: "",
};

/**
 * Get Scrap details
 */
export const getScrapDetails = createAsyncThunk(
  "getScrapDetails",
  async (params, thunkAPI) => {
    const newParams = {
      ...params,
      crew: params.crew === ALL_CREWS ? null : params.crew,
    };
    const url = `${JSON.parse(localStorage.berryConfig).URL}scrapdetails`;
    try {
      const resp = await axios.post(url, newParams);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to get scrap details list");
    }
  }
);

/**
 * Add and update scrap details
 * if machineworkDetailId is null then add if its has value then update call
 */
export const addScrapDetails = createAsyncThunk(
  "addScrapDetails",
  async (params, thunkAPI) => {
    const newParams = {
      ...params,
      crew: params.crew === ALL_CREWS ? null : params.crew,
    };
    const url = `${JSON.parse(localStorage.berryConfig).URL}scrapdetails/add`;
    try {
      const resp = await axios.post(url, newParams);
      return resp.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response && err.response.data && err.response.data.message);
    }
  }
);

/**
 * Delete scrap details
 */
export const deleteScrapDetails = createAsyncThunk(
  "deleteScrapDetails",
  async (params, thunkAPI) => {
    const url = `${
      JSON.parse(localStorage.berryConfig).URL
    }scrapdetails/delete`;
    try {
      const resp = await axios.delete(url, { data: params });
      return resp.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response && err.response.data && err.response.data.message);
    }
  }
);

export const ScrapDetailsSlice = createSlice({
  initialState,
  name: "scrapState",
  extraReducers: (builder) => {
    builder
      .addCase(getScrapDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getScrapDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload;
      })
      .addCase(getScrapDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload;
      })
      .addCase(addScrapDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addScrapDetails.fulfilled, (state, action) => {
        state.message = action.payload.message;
        state.isLoading = false;
        state.statusText = "success";
        state.severity = "success";
      })
      .addCase(addScrapDetails.rejected, (state, action) => {
        state.message = action.payload;
        state.isLoading = false;
        state.statusText = "failed";
        state.severity = "error";
      })
      .addCase(deleteScrapDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteScrapDetails.fulfilled, (state, action) => {
        state.message = action.payload.message;
        state.isLoading = false;
        state.statusText = "success";
        state.severity = "success";
      })
      .addCase(deleteScrapDetails.rejected, (state, action) => {
        state.message = action.payload.message;
        state.isLoading = false;
        state.statusText = "failed";
        state.severity = "error";
      });
  },
});

export default ScrapDetailsSlice.reducer;
